import { Action } from '@ngrx/store';
import {
  AvailableSpeedResource,
  TechnicalError,
} from '@dch/products-business-logic';

export const GET_AVAILABLE_SPEED = 'GET_AVAILABLE_SPEED';
export const GET_AVAILABLE_SPEED_SUCCESS = 'GET_AVAILABLE_SPEED_SUCCESS';
export const GET_AVAILABLE_SPEED_FAILED = 'GET_AVAILABLE_SPEED_FAILED';

export class GetAvailableSpeed implements Action {
  type = GET_AVAILABLE_SPEED;

  constructor(public payload?: any) {}
}

export class GetAvailableSpeedSuccess implements Action {
  type = GET_AVAILABLE_SPEED_SUCCESS;

  constructor(public payload: AvailableSpeedResource) {}
}

export class GetAvailableSpeedFailed implements Action {
  type = GET_AVAILABLE_SPEED_FAILED;

  constructor(public payload: TechnicalError) {}
}

export type Actions =
  | GetAvailableSpeed
  | GetAvailableSpeedSuccess
  | GetAvailableSpeedFailed;
